import React, { FC } from "react";
import clsx from "clsx";

import { ReactComponent as IconArrowNext } from "../../../../assets/images/Career/ChallengeSheet/icon_arrow_next.svg";
import { ReactComponent as IconArrowPrevious } from "../../../../assets/images/Career/ChallengeSheet/icon_arrow_previous.svg";
import { MIN_SHEET_INDEX, MAX_SHEET_INDEX } from "../index";

import styles from "./Pagination.module.scss";

type Props = {
  index: number;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSave: () => void;
};

const Pagination: FC<Props> = ({ index, canNext, onPrev, onNext, onSave }) => {
  return (
    <div className={styles.pagination}>
      {MIN_SHEET_INDEX < index && (
        <button
          className={clsx(styles.button, styles.prev)}
          onClick={() => onPrev()}
        >
          <IconArrowPrevious />
        </button>
      )}
      <span className={styles.progressFraction}>
        {index}/{MAX_SHEET_INDEX}
      </span>
      {MAX_SHEET_INDEX > index && (
        <button
          className={clsx(styles.button, styles.next)}
          disabled={canNext}
          onClick={() => {
            onNext();
            onSave();
          }}
        >
          <IconArrowNext />
        </button>
      )}
    </div>
  );
};

export default Pagination;
